export const DEFAULT_NOTIFICATION_DURATION = 20000;
